import type { AuditMetrics } from "../audit/types";

export interface HistoryEntry extends AuditMetrics {
  id: string;
  createdAt: string;
  sourceName: string;
  durationMs: number;
  version: string;
}

const key = "sl-call-status-audit-history-v2";

export function readHistory(): HistoryEntry[] {
  try {
    const data = JSON.parse(localStorage.getItem(key) || "[]");
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

export function addHistory(entry: Omit<HistoryEntry, "id" | "createdAt">): HistoryEntry[] {
  const items = [{ ...entry, id: crypto.randomUUID(), createdAt: new Date().toISOString() }, ...readHistory()].slice(0, 180);
  try { localStorage.setItem(key, JSON.stringify(items)); } catch { /* Storage may be disabled by policy. */ }
  return items;
}
